/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Import_Stat_ConflictsInputs */

const cs_import_stat_conflicts = /** @type {(inputs: Import_Stat_ConflictsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Konflikty: ${i?.count}`)
};

const en_import_stat_conflicts = /** @type {(inputs: Import_Stat_ConflictsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Conflicts: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Conflicts: {count}" |
*
* @param {Import_Stat_ConflictsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_stat_conflicts = /** @type {((inputs: Import_Stat_ConflictsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Stat_ConflictsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_stat_conflicts(inputs)
	return cs_import_stat_conflicts(inputs)
});